import React from 'react'
import {ChartFrame} from '@containers/monitoringPlatform/passengerCharts/types'

const WIDTH = 180
const Y_MAX = 50
const ACCENT = 'var(--account-accent, #0C6DDF)'

interface IProps {
	frames: ChartFrame[]
	from: number
	to: number
	height: number
}

const Sparkline = ({frames, from, to, height}: IProps) => {
	const span = Math.max(1, to - from)
	const x = (t: number) => (WIDTH * (t - from)) / span
	const y = (v: number) => height - 2 - ((height - 6) * Math.min(v, Y_MAX)) / Y_MAX
	const line = frames.length ? 'M' + frames.map(([t, v]) => `${x(t).toFixed(1)},${y(v).toFixed(1)}`).join('L') : ''

	return (
		<svg viewBox={`0 0 ${WIDTH} ${height}`} style={{display: 'block', width: '100%', height: 'auto'}}>
			{line && <path
				d={`${line}L${x(frames[frames.length - 1][0])},${height}L${x(frames[0][0])},${height}Z`}
				fill={ACCENT}
				fillOpacity={0.15}
			/>}
			{line && <path d={line} stroke={ACCENT} strokeWidth={1.2} fill="none"/>}
			{!line && <line x1={0} x2={WIDTH} y1={height - 2} y2={height - 2} stroke="currentColor" strokeOpacity={0.2}/>}
		</svg>
	)
}

export default Sparkline
